import { getV4, postV4 } from '@/common/utils/ajax'

const getChatListCategories = () => getV4('user_messages/categories')
const getChatList = (params) => getV4('user_messages', params)
const readAllUserMessages = (params) => postV4('user_messages/read_all', params)

export default {
    getChatListCategories,
    getChatList,
    readAllUserMessages
}